import React, { useEffect, useState } from "react";
import OtherHero from "../../Components/Breadcrumb/OtherHero/OtherHero";
import {
  aboutBg,
  preferences1,
  preferences2,
  preferences3,
  preferences4,
  preferences5,
} from "../../assets/images";
import { useTranslation } from "react-i18next";
import axios from "axios";

const About = () => {
  const { t } = useTranslation();

  const [settings, setSettings] = useState([]);

  useEffect(() => {
    getQhse();
  }, []);

  async function getQhse() {
    try {
      // API'den verileri çekiyoruz
      const response = await axios.get(
        "https://www.caspianrocksolutions.com/caspianrocksolutions/about.php"
      );
      setSettings(response.data.data[0]); // Gelen veriyi state'e kaydediyoruz
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error); // Hata durumunda mesaj yazdırıyoruz
    }
  }

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <OtherHero
          title="About"
          content="Engineering smart solutions for a dynamic industry"
        />
      </div>
      <div className="bg-[#EDEDED] py-10 md:py-20 ">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex justify-between">
          <div className="md:w-[634px]">
            <p className="text-[#B31F11] text-[14px] font-medium">ABOUT US</p>
            <p className="text-[28px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {settings.title}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {settings.content}
            </p>
            <div className="mt-5">
              <a
                href={`https://www.caspianrocksolutions.com/caspianrocksolutions/${settings.presentation}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#B31F11] border border-[#B31F11] py-2 px-4 rounded-md hover:bg-[#B31F11] hover:text-white transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                {t("CRS Presentation")}
              </a> 
            </div>
          </div>
          <div className="md:w-[480px] flex justify-between items-center mt-6 md:mt-0">
            <img
              alt="About"
              className="md:w-[530px] w-full rounded-xl"
              src={`https://www.caspianrocksolutions.com/caspianrocksolutions/${settings.image}`}
            ></img>
          </div>
        </div>
        <div className="text-[#141615] max-w-containerSm md:max-w-container mx-auto mt-[80px]">
          <p className="font-firstFont text-[28px] md:text-[44px] font-bold text-center">
            Basic Principles of the Company
          </p>
          <div className="grid grid-cols-1 md:grid-cols-5 mt-[60px] space-y-6 md:space-y-0">
            <div className="w-[220px] flex flex-col items-center mx-auto md:mx-0">
              <img
                alt="Effectiveness"
                className="w-[64px] h-[64px]"
                src={preferences1}
              ></img>
              <p className="text-[24px] font-medium mt-4 md:mt-8 text-center">
                Effectiveness
              </p>
            </div>
            <div className="w-[220px] flex flex-col items-center mx-auto md:mx-0">
              <img
                alt="Quality"
                className="w-[64px] h-[64px]"
                src={preferences2}
              ></img>
              <p className="text-[24px] font-medium mt-4 md:mt-8 text-center">
                Quality
              </p>
            </div>
            <div className="w-[220px] flex flex-col items-center mx-auto md:mx-0">
              <img
                alt="Individual approach"
                className="w-[64px] h-[64px]"
                src={preferences3}
              ></img>
              <p className="text-[24px] font-medium mt-4 md:mt-8 text-center">
                Individual approach
              </p>
            </div>
            <div className="w-[220px] flex flex-col items-center mx-auto md:mx-0">
              <img
                alt="Use of new technologies"
                className="w-[64px] h-[64px]"
                src={preferences4}
              ></img>
              <p className="text-[24px] font-medium mt-4 md:mt-8 text-center">
                Use of new technologies
              </p>
            </div>
            <div className="w-[220px] flex flex-col items-center mx-auto md:mx-0">
              <img
                alt="Mobility"
                className="w-[64px] h-[64px]"
                src={preferences5}
              ></img>
              <p className="text-[24px] font-medium mt-4 md:mt-8 text-center">
                Mobility
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
